import useSWR from 'swr';
import apiClient from '../canopy-ui-components/api';
import analyticsClient from '../canopy-ui-components/api/analytics';
import { getApiURL } from '../canopy-ui-components/api/newUtils';

export const useLayoutStateSWR = (apiData: any, layoutState: any) => {
    const url =
        apiData?.endpoint && apiData?.endpointParams
            ? getApiURL(apiData?.endpoint, apiData?.endpointParams, layoutState)
            : null;
    const client =
        apiData?.endpointDomain === 'analytics' ? analyticsClient : apiClient;
    const { data, error, isValidating, mutate } = useSWR(
        [url, apiData?.endpointVersion || 'v2'],
        client.fetcher.bind(client),
        {
            revalidateOnFocus: false,
            shouldRetryOnError: true,
        }
    );
    if (apiData?.endpoint && apiData?.endpointParams) {
        return {
            data,
            error,
            loading: !data && !error,
            mutate,
            isValidating,
            url,
            endpointVersion: apiData?.endpointVersion,
            endpointDomain: apiData?.endpointDomain,
        };
    }
    return {};
};
